import { Injectable } from '@angular/core';
import { ConnectNotificationType } from '@epicuro-next/platform/configuration';
import * as fromSignalrState from '@epicuro-next/state/signalr-state';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { of } from 'rxjs';
import { concatMap, map, withLatestFrom } from 'rxjs/operators';

import * as actions from '../actions';
import { selectUserCurrentContactState } from '../selectors';

@Injectable()
export class ConnectCallEffects {
  constructor(private actions$: Actions, private store: Store) {}

  public cancelVideoCall$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.cancelCall),
      concatMap(({ roomId }) =>
        of(roomId).pipe(
          withLatestFrom(
            this.store.pipe(select(selectUserCurrentContactState)),
          ),
        ),
      ),
      map(([roomId, contact]) =>
        fromSignalrState.sendSignalrMessage({
          methodName: ConnectNotificationType.CancelVideoCall,
          params: [contact?.email, roomId],
        }),
      ),
    ),
  );
}
